import { AssetReference } from './index';
const basicCharacterPropertyToUnitMap = {
    font: 'FontStyle',
    textColor: 'Color',
    fontSize: 'number',
    lineHeight: 'number',
    characterSpacing: 'number',
    uppercase: 'boolean',
    underline: 'boolean',
    strikethrough: 'boolean',
    textShadows: 'TextShadow[]',
    variable: 'Feed'
};
export const characterPropertyToUnitMap = Object.assign(Object.assign({}, basicCharacterPropertyToUnitMap), { 
    // A helper property to display, font family in dropdown, when font style is undefined.
    __fontFamilyId: 'string' });
const textPropertiesOnlyToUnitMap = {
    maxRows: 'integer',
    padding: 'Padding',
    textOverflow: 'enum',
    horizontalAlignment: 'enum',
    verticalAlignment: 'enum',
    textColor: 'Color'
};
export const textPropertyToUnitMap = Object.assign(Object.assign({}, characterPropertyToUnitMap), textPropertiesOnlyToUnitMap);
function getObjectKeys(object) {
    return Object.keys(object);
}
export const textProperties = getObjectKeys(textPropertyToUnitMap);
export const characterProperties = getObjectKeys(basicCharacterPropertyToUnitMap);
export const widgetPropertyToUnitMap = {
    js: 'string',
    ts: 'string',
    html: 'string',
    css: 'string',
    customProperties: 'CustomProperty[]',
    [AssetReference.Widget]: 'string',
    bannerflowLibraryWidgetReference: 'string',
    select: 'CustomProperty[]',
    number: 'number',
    image: 'ImageAsset',
    boolean: 'boolean',
    color: 'Color',
    widgetAsset: 'WidgetAsset'
};
const imagePropertyToUnitMap = {
    [AssetReference.Image]: 'string',
    imageAsset: 'ImageAsset',
    imageSettings: 'ImageSettings'
};
const videoPropertyToUnitMap = {
    videoAsset: 'VideoAsset',
    videoSettings: 'VideoSettings'
};
export const unitToVersionedUnitMap = {
    text: 'content',
    feed: 'feed'
};
const basicSharedPropertyToUnitMap = {
    x: 'number',
    y: 'number',
    fill: 'Color',
    originX: 'number',
    originY: 'number',
    rotationX: 'number',
    rotationY: 'number',
    rotationZ: 'number',
    radius: 'Radius',
    opacity: 'number',
    shadows: 'Shadow[]',
    filters: 'FilterMap',
    border: 'Border',
    mirrorX: 'boolean',
    mirrorY: 'boolean',
    scaleX: 'number',
    scaleY: 'number',
    ratio: 'number',
    masking: 'Masking'
};
export const sharedPropertyToUnitMap = Object.assign(Object.assign({}, basicSharedPropertyToUnitMap), { width: 'number', height: 'number', duration: 'number', hidden: 'boolean', locked: 'boolean', feed: 'Feed', states: 'State[]', animations: 'Animation[]', actions: 'Action[]', time: 'number', 
    // TODO: SHOULD NOT BE IN SHARED
    content: 'text' });
export const statePropertyToUnitMap = Object.assign(Object.assign({}, basicSharedPropertyToUnitMap), { name: 'string' });
export const textStatePropertyToUnitMap = Object.assign(Object.assign({}, statePropertyToUnitMap), { textColor: 'IColor' });
export const allStateProperties = Object.assign(Object.assign({}, statePropertyToUnitMap), textStatePropertyToUnitMap);
export const propertyToUnitMap = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, textPropertyToUnitMap), widgetPropertyToUnitMap), imagePropertyToUnitMap), videoPropertyToUnitMap), sharedPropertyToUnitMap), statePropertyToUnitMap);
export const properties = getObjectKeys(propertyToUnitMap);
export const sharedProperties = getObjectKeys(sharedPropertyToUnitMap);
/**
 * Element properties that need to be scaled in order to scale a creative to any particular size
 */
export const ScalableProperties = [
    'x',
    'y',
    'width',
    'height',
    'scaleX',
    'scaleY',
    'fitPositionX',
    'fitPositionY',
    'radius',
    'border',
    'fontSize',
    'padding',
    'shadows',
    'textShadows'
];
export function isElementProperty(key) {
    return properties.some(p => key === p);
}
export const propertyMaxValues = {
    opacity: 1
};
export const propertyMinValues = {
    radius: 0,
    opacity: 0,
    scaleX: 0,
    scaleY: 0
};
